import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const IOS_URL = "https://apps.apple.com/app/notely-ai/id6740462619";
const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.cstate.notelyapp";
const MACOS_URL = "https://apps.apple.com/app/notely-ai/id6740462619?platform=mac";

const RedeemRedirect: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const [showFallback, setShowFallback] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (code) {
      window.location.href = `notelyai://redeem?code=${code}`;
    }

    const timer = setTimeout(() => {
      setShowFallback(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, [code]);

  if (!showFallback) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl font-semibold mb-4">{t('downloadRedirect.redirecting')}</div>
          <div className="text-gray-400">{t('downloadRedirect.takingYou')}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-bold mb-4">Get Notely to redeem your code</h1>
        <p className="text-gray-400 mb-2">Code: <span className="font-mono text-white">{code}</span></p>
        <p className="text-gray-400 mb-8">Download Notely, then open this link again to redeem your promo code.</p>

        <div className="space-y-4">
          <a
            href={IOS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200"
          >
            {t('downloadRedirect.downloadIos')}
          </a>

          <a
            href={ANDROID_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200"
          >
            {t('downloadRedirect.downloadAndroid')}
          </a>

          <a
            href={MACOS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-gray-600 hover:bg-gray-500 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200"
          >
            {t('downloadRedirect.downloadMac')}
          </a>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          {t('downloadRedirect.notRedirected')}
        </p>
      </div>
    </div>
  );
};

export default RedeemRedirect;
